import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

import NSFHeader from "../../components/NSF/NSFHeader";
import NSFStatsCards from "../../components/NSF/NSFStatsCards";
import NSFCasesTable from "../../components/NSF/NSFCasesTable";
import NSFHistoryModal from "../../components/NSF/NSFHistoryModal";
import { useNSF } from "../../hooks/useNSF";
import styles from "./Nsf.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchNsfData } from "../../store/reducers/nsfSlice/api";

const NSF = () => {
  const dispatch = useDispatch();
  const { data, status: nsfStatus } = useSelector((state) => state.nsf.nsfData);
  const accounts = useSelector((state) => state.account.accountOptions)
    .map((data) => data.value)
    .join(" ");
  const accountsNumber = useSelector(
    (state) => state.account.accountOptions
  ).map((data) => data.label.split(" - ")[1]);

  const {
    selectedCase,
    handleSendAlert,
    handleSendNSFAlert,
    showHistoryModal,
    historyItems,
    handleShowHistory,
    handleCloseHistory,
  } = useNSF();

  useEffect(() => {
    if (data === null) {
      dispatch(fetchNsfData({ accounts, accountsNumber }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts, dispatch, data]);

  return (
    <div className={`${styles.pageContainer} ${styles.nsfComponent}`}>
      <section className={`rounded container-fluid ${styles.sectionContainer}`}>
        <Container className={`p-4 ${styles.contentContainer}`}>
          <NSFHeader onSendNSFAlert={handleSendNSFAlert} />

          <NSFStatsCards />

          {nsfStatus === "fulfilled" && Array.isArray(data?.cases) && (
            <NSFCasesTable
              cases={data.cases}
              onSendAlert={handleSendAlert}
              onShowHistory={handleShowHistory}
            />
          )}
        </Container>
      </section>

      <NSFHistoryModal
        show={showHistoryModal}
        onHide={handleCloseHistory}
        items={historyItems}
        title={
          selectedCase ? `NSF History - ${selectedCase.borrower}` : "History"
        }
        caseData={selectedCase}
      />
    </div>
  );
};

export default NSF;
